<template>
    <div class="PostData spackage padding-20 bgc box-shadow">
        <!-- start 顶部菜单栏 -->

        <el-form :model="form" :rules="rules">
            <el-form-item label="选择马甲" placeholder="选择马甲">
                <el-select v-model="form.innerid">
                    <el-option v-for="item in vestlist" :key="item.innerid" :value="item.innerid" :label="item.name"></el-option>
                </el-select>

            </el-form-item>
            <el-form-item label="增加资料">
                <div class="upload-pdf">
                    <uploadFile v-if="form.logodata.length < 3" :uploadType="uploadVideoType" @setFile="setFile" :fileRule="fileRule"></uploadFile>
                    <el-button type="info" v-else>上传附件...</el-button>
                    <span style="margin-left: 20px">还可以上传 {{ 3 - form.logodata.length }} 份资料</span>
                </div>
                <div class="pdfMsg" v-if="form.logodata">
                    <div class="item" v-for="(logodata,index) in form.logodata">
                        <span class="fname">{{logodata.fname}}</span><span>{{fsize(logodata.fsize)}}</span><span class="delPdf" @click="delPdf(index)">删除</span>
                    </div>
                </div>

            </el-form-item>
            <el-form-item label="内容详情" porp="content">
                <div class="ueditorBox">
                    <uEditor :content="form.content" ref="uEditor" @getUEditorContent="getMsgContent"></uEditor>
                </div>
            </el-form-item>

            <el-form-item label=" ">
                <el-button style="margin-left: 80px" type="primary" @click="add">保存并发布</el-button>
            </el-form-item>
        </el-form>

    </div>
</template>

<script>
    import { findAllStarsockpuppet, saveStarsockpuppetFile} from '@/api/communityApi'
    import UEditor from 'base/uEditor/uEditor'
    import UploadFile from 'base/upload/uploadFile'
    import Loading from 'base/loading/loading' // 引入 loading 组件
    import {computeFileSize, formatFileInfo} from 'common/js/tools'
    import {mapGetters,mapActions} from 'vuex'
    export default {
        name: "PostData",
        props: ['innerid'],
        data() {
            let validatePdfInfo = (rule, value, callback) => {
                if (!this.form.logodata) {
                    callback(new Error('请上传PDF文件'))
                } else {
                    callback()
                }
            }
            return {
                vestlist: [],   // 马甲列表
                uploadVideoType: {
                    catecode: '94',
                    datatype: 'FILE'
                },
                form: {
                    starinnerid: this.innerid,
                    innerid: '',    // 话题innerid
                    logodata: [],
                    content: '',
                    contenttype: 3,

                },
                fileRule: {
                    btnName: '上传附件...',
                    cls: '',
                    accept: 'application/pdf',
                    size: 10,
                    width: '',
                    height: ''
                },
                rules: {
                    logodata : [
                        { required: true, message: '请上传pdf文件', trigger: 'blur' }
                        ],
                    content: [
                        { required: true, message: '请输入内容详情', trigger: 'blur' },
                    ],
                    innerid: [
                        { required: true, message: '请选择马甲', trigger: 'blur' },
                    ]
                }
            }
        },
        mounted() {

            // 取得马甲列表
            this.getfindAllStarsockpuppet();

            // // 取得话题列表
            // this.tablist()
            //

        },
        methods: {
            initform() {
                this.$nextTick(() => {
                    this.form = {
                        starinnerid: this.innerid,
                        innerid: '',    // 话题innerid
                        logodata: [],
                        content: '',
                        contenttype: 3,
                    }
                    this.$refs.uEditor.init('')
                })
            },
            // 内容详情
            getMsgContent(content) {
                this.form.content = content
            },
            setFile(file) {
                computeFileSize()
                delete file.type
                // console.log('file',file)
                this.form.logodata.push(file)
                // = file
            },
            delPdf(index) {
                let len = this.form.logodata.length,
                    logolist = this.form.logodata

                for (let i = 0; i < len; i++ ) {
                    if ( i === index ) {
                        this.$nextTick(() => {
                            logolist.splice(i,1)
                        })
                    }
                }
            },
            back() {
                this.$router.go(-1)
            },
            add() {
                let data = JSON.parse(JSON.stringify(this.form))

                if (data.content === "") {
                    this.$message.error('内容不能为空')
                } else {

                    data.logodata = JSON.stringify(data.logodata)

                    this.setLoading(true)
                    saveStarsockpuppetFile({
                        data: data,
                        success: data => {
                            this.$message.success('保存成功')
                            this.setLoading(false)

                            this.initform()
                        },
                        error: data => {
                            this.$message.error(data.msg)
                            this.setLoading(false)
                        }
                    })
                }
            },
            getfindAllStarsockpuppet() {
                let dataapi = {
                    starinnerid: this.form.starinnerid
                }
                this.setLoading(true)
                findAllStarsockpuppet({
                    data: dataapi,
                    success:data => {
                        this.vestlist = data.data
                        this.setLoading(false)
                    },
                    error:data => {
                        this.setLoading(false)
                    }
                })
            },
            // tablist() {
            //     let dataapi = {
            //         starinnerid: this.form.starinnerid
            //     }
            //     this.setLoading(true)
            //     getStarTagList({
            //         data: dataapi,
            //         success:data => {
            //             this.taglist = data.data
            //             this.setLoading(false)
            //         },
            //         error:data => {
            //             this.setLoading(false)
            //         }
            //     })
            //
            // },
            ...mapActions([
                'setLoading'
            ]),
        },
        computed: {
            fsize () {
                return function(size) {
                    return computeFileSize(size)
                }
            },
        },
        components: {
            Loading,
            UEditor,
            UploadFile
        },
    }
</script>

<style lang="scss" type="text/scss">
    @import "~common/scss/variable";
    @import "~common/scss/mixin";
    .PostData {
        #edui62 {
            display: none !important
        }
        .el-input__icon {
            line-height: normal;
        }
        .name {
            margin-bottom: 20px;
            padding-left: 8px;
            font-size: 16px;
            font-weight: bold;
            border-left: solid 2px #00a0e9;
        }

        .pdfMsg{
            margin-top: 20px;
            margin-left: 78px;
            width: 264px;
            /*height: 40px;*/
            line-height: 40px;
            box-sizing: border-box;
            padding: 0 20px;
            overflow: hidden;
            background: #DCDFE6;
            /*display: flex;*/
            /*justify-content: space-around;*/
            margin-bottom: 10px;
            .delPdf{
                color: #409EFF;
                cursor: pointer;
            }
            .fname{
                width: 100px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                display: inline-block;
            }
            .item {
                display: block;
                width: 100%;
                span {
                    float: left;
                    padding-right: 10px;
                }
            }
        }
        .upload-pdf{
            @include flexBox(flex-start);
        }
    }
</style>
